import { Injectable, Injector } from '@angular/core';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { Vars } from '../model/vars';
import { Observable } from 'rxjs/Observable';
import { catchError, map, tap } from 'rxjs/operators';
import { ReportAttendanceSummary } from '../model/report-attendance-summary';
import * as FileSaver from 'file-saver';

@Injectable()
export class ReportAttendanceSummaryService extends BaseReportService<ReportAttendanceSummary> {

  public uri = '/api/reportAttendanceSummary/';

  constructor(injector: Injector) {
    super(injector);
    //console.log('Instance ReportAttendanceSummary');
  }

  buildSentence(entity?: ReportAttendanceSummary, event?: LazyLoadEvent): HttpParams {
    return null;
  }

  searchToViewTable(fiscalYear: any,
    executingUnit: any,
    month: any,
    payrollType: any,
    employeeType: any,
    sign: any,
    payrollConcept?: any,
    costCenter?: any,
    employee?: any,
    object?: Vars
  ): Observable<any> {
    const params = new HttpParams()
      .set('fiscalYearId', fiscalYear)
      .set('euId', executingUnit)
      .set('monthId', month)
      .set('payrollTypeId', payrollType)
      .set('employeeTypeId', employeeType)
      .set('sign', sign)
      .set('payrollConceptId', payrollConcept)
      .set('costCenterId', costCenter)
      .set('employeeId', employee)
    this.spinnerService.showAll();
    const url = `${this.rutaServidor}${this.uri}search`;
    return this.httpClient.post<any>(url, object, { params },)
      .pipe(
        tap(response => {
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  downloadData(url: string, object: any): Observable<any> {
    // console.log('LLAMADA A downloadData', this.rutaServidor + this.uri + url);
    let ruta = this.rutaServidor + this.uri + url;
    this.spinnerService.showAll();
    return this.httpClient.post(ruta, object)
      .pipe(
        catchError((e) => {
          this.spinnerService.hideAll();
          return Observable.throw(e.status + ' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');

        }),
        map(res => {
          return res;
        })
      );
  }

  verifyCreationFinished(object: any): Observable<Blob> {
    let ruta = this.rutaServidor + this.uri + 'verifyCreationFinished';
    //this.spinnerService.showAll();  
    return this.httpClient.post(ruta, object, { responseType: 'blob' })
      .pipe(
        catchError((e) => {
          return Observable.throw(e.status + ' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');

        }),
        map(res => {
          //console.log(res);
          this.spinnerService.hideAll();
          let bean = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          FileSaver.saveAs(bean, object.nameFile);
          return bean;
        })
      );

  }

  processBatchgeneratePDFToFTP(url:string ,object: any ): Observable<any> {
      let ruta = this.rutaServidor + this.uri   +  url; 
      this.spinnerService.showAll();
      return this.httpClient.post(ruta, object)
          .pipe( 
            tap(response => {
              this.spinnerService.hideAll();
              return response;
            }),
              catchError((err) => { 
                  //console.log("catchError : "  + catchError);
                  this.spinnerService.hideAll();
                  this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
                  return new Observable<Blob>();
              })
                
              ) ;

  }


      downloadCSV(url:string ,object: any , nameFile : string): Observable<any> {
          let ruta = this.rutaServidor + this.uri   +  url;
          //console.log("ruta : "  + ruta);
           this.spinnerService.showAll(); 
          return this.httpClient.post(ruta, object, {responseType: 'blob' })
              .pipe( 
                  map(res =>  {   
                      this.spinnerService.hideAll();
                      // let bean = new Blob([res]);
                      // FileSaver.saveAs(bean, nameFile);
                      return res;
                  }),
                  catchError((err, caught) => { 
                      //console.log("catchError : "  + catchError);
                      this.spinnerService.hideAll(); 
                      this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
                      return new Observable<Blob>();
                  }) 
                   
              ); 
   
      }
  downloadCSVtwo(url: string, object: any, fileName: string): Observable<any> {
  const ruta = this.rutaServidor + this.uri + url;

  return this.httpClient.post(ruta, object, { responseType: 'blob' })
    .pipe(
      map((res: Blob) => {
        const blob = new Blob([res], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();

        window.URL.revokeObjectURL(url);

        return res;
      }),
      catchError((err, caught) => { 
          //console.log("catchError : "  + catchError);
          this.spinnerService.hideAll(); 
          this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
          return new Observable<Blob>();
       }) 
    );
}



}



// WEBPACK FOOTER //
// ./src/app/core/services/report-attendance-summary.service.ts